import React from 'react';
import { motion } from 'framer-motion';
import { MousePointerClick, Lightbulb, PieChart, FileCheck } from 'lucide-react';
export function Slide8Outputs() {
  const cards = [{
    title: 'Engagement',
    icon: MousePointerClick,
    desc: 'HCPs interact with approved content in a snackable format.',
    color: 'text-blue-500',
    bg: 'bg-blue-50'
  }, {
    title: 'Insight',
    icon: Lightbulb,
    desc: 'Takeda sees what HCPs know, believe and want to explore.',
    color: 'text-yellow-500',
    bg: 'bg-yellow-50'
  }, {
    title: 'Segmentation',
    icon: PieChart,
    desc: 'Results can be grouped by role, specialty, market or topic interest.',
    color: 'text-[#6B46C1]',
    bg: 'bg-[#6B46C1]/10'
  }, {
    title: 'Recommendation',
    icon: FileCheck,
    desc: 'Snakker delivers a short report with recommendations for the next campaign step.',
    color: 'text-[#E60012]',
    bg: 'bg-[#E60012]/10'
  }];
  return <div className="h-full w-full bg-[#F8F9FA] text-[#2D3748] flex flex-col p-12 md:px-24 md:pt-20 md:pb-28 relative overflow-hidden" data-id="element-255">
      <header className="mb-10 text-center" data-id="element-256">
        <motion.h2 className="text-4xl md:text-5xl font-bold text-[#1A202C] mb-4" initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-257">
          One focused use case.{' '}
          <span className="text-[#E60012]" data-id="element-258">Four useful outputs.</span>
        </motion.h2>
      </header>

      <main className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto w-full" data-id="element-259">
        {cards.map((card, index) => {
        const Icon = card.icon;
        return <motion.div key={card.title} className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 flex items-start gap-6 hover:shadow-md transition-shadow" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2 + index * 0.1
        }} data-id="element-260">
              <div className={`p-4 rounded-xl ${card.bg} shrink-0`} data-id="element-261">
                <Icon className={`w-8 h-8 ${card.color}`} data-id="element-262" />
              </div>
              <div data-id="element-263">
                <h3 className="text-2xl font-bold text-[#1A202C] mb-3" data-id="element-264">
                  {card.title}
                </h3>
                <p className="text-[#4A5568] leading-relaxed" data-id="element-265">{card.desc}</p>
              </div>
            </motion.div>;
      })}
      </main>

      <motion.footer className="mt-8 text-center" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.6,
      delay: 0.8
    }} data-id="element-266">
        <p className="text-xl font-medium text-[#2D3748] bg-white inline-block px-8 py-4 rounded-full shadow-sm border border-gray-100" data-id="element-267">
          The pilot is not just content.{' '}
          <span className="text-[#E60012]" data-id="element-268">
            It is a diagnostic tool for better campaign decisions.
          </span>
        </p>
      </motion.footer>
    </div>;
}